import React from 'react';
import { Chip } from '@mui/material';
import { Delete } from '@mui/icons-material';

const ProductCategoryChip = ({ category, onDelete }) => {
  return (
    <Chip
      label={`${category.type_name}: ${category.value}`}
      color="primary"
      sx={{ textTransform: 'capitalize', mb: 1 }}
      deleteIcon={<Delete />}
      onDelete={() => onDelete(category.product_category_id)}
    />
  );
};

export default ProductCategoryChip;
